import { render, staticRenderFns } from "./IconVerwarmingKruis.vue?vue&type=template&id=587821d6"
import script from "./IconVerwarmingKruis.vue?vue&type=script&lang=ts"
export * from "./IconVerwarmingKruis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports